import { format } from "date-fns";
import { CalendarIcon } from "@credcore/core-ui/icons";
import { cn } from "@/lib/utils";
import { Button } from "../Button";
import { Calendar } from "./Calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../Popover";

interface DatePickerProps {
  date?: Date;
  onDateChange?: (date: Date | undefined) => void;
  placeholder?: string;
  compact?: boolean;
}

export function DatePicker({
  date,
  onDateChange,
  placeholder = "Pick a date",
  compact = false,
}: DatePickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          size={compact ? "sm" : "default"}
          className={cn(
            "justify-start text-left font-normal",
            compact ? "w-auto px-2" : "w-full",
            !date && "text-muted-foreground",
          )}
        >
          <CalendarIcon
            className={cn(compact ? "mr-1 h-3 w-3" : "mr-2 h-4 w-4")}
          />
          {date ? (
            format(date, compact ? "MM/dd/yy" : "PPP")
          ) : (
            <span>{placeholder}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={date}
          onSelect={onDateChange}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
